import { OrdersCart } from '@/entities/cart-page/OrdersCart/ui/OrdersCart'
import './ui/OrdersCart.scss'
export default OrdersCart
